import { SxProps, Theme, Typography } from '@mui/material';
import { DynamicIcon, PartnerTimeZoneTooltip } from 'src/components';
import { IconLibrary } from 'src/components/DynamicIcon/dynamic-icon';

const getChatInfoIconSx = (iconLibrary: IconLibrary): SxProps<Theme> =>
  iconLibrary === 'lucide'
    ? { flexShrink: 0 }
    : {
        flexShrink: 0,
        justifyContent: 'center',
        lineHeight: 1,
        fontSize: '0.9375rem !important',
      };

export const ChatInfoWithTimestamp = ({
  message,
  date,
  partnerId,
  color,
  icon,
  iconLibrary = 'material-symbols',
}: {
  icon: string;
  iconLibrary?: IconLibrary;
  message: string;
  date: string;
  partnerId: number;
  color?: string;
}) => {
  return (
    <>
      <DynamicIcon
        name={icon}
        library={iconLibrary}
        size={15}
        sx={getChatInfoIconSx(iconLibrary)}
      />
      <PartnerTimeZoneTooltip date={date} partnerId={partnerId}>
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600,
            textWrap: 'wrap',
            color,
            minWidth: 0,
            lineHeight: 1.3125,
          }}
        >
          {message}
        </Typography>
      </PartnerTimeZoneTooltip>
    </>
  );
};
